import * as React from 'react';

import { PromoCompilationItemLayout, PromoCompilationsLayout } from '../../../../components/PromoCompilation';
import { PromoCompilationItemContainer } from '../PromoCompilationItem';

export const PromoCompilationsContainer: React.FC = () => {
  return (
    <PromoCompilationsLayout>
      <PromoCompilationItemLayout>
        <PromoCompilationItemContainer type={'topPromos'} />
      </PromoCompilationItemLayout>
      <PromoCompilationItemLayout>
        <PromoCompilationItemContainer type={'lastChanceDiscount'} />
      </PromoCompilationItemLayout>
    </PromoCompilationsLayout>
  );
};
